const omittedKeys = new Set([
  "$request_params",
  "$job_arguments",
  "title",
  "$title",
  "page_title",
])
const sensitiveKey =
  /^(sid|token|password|password_confirmation|secret|authorization)$/i
const urlKey = /(url|path|pathname|referrer)$/i

export function sanitizeAnalyticsUrl(value: string): string {
  return value
    .split(/[?#]/, 1)[0]
    .replace(/(\/digest\/unsubscribe\/)[^/]+/g, "$1[REDACTED]")
}

export function sanitizeAnalyticsValue(value: unknown, key = ""): unknown {
  if (sensitiveKey.test(key)) return "[FILTERED]"
  if (Array.isArray(value)) {
    return value.map((item: unknown) => sanitizeAnalyticsValue(item, key))
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([name]) => !omittedKeys.has(name))
        .map(([name, item]: [string, unknown]) => [
          name,
          sanitizeAnalyticsValue(item, name),
        ]),
    )
  }
  if (typeof value === "string") {
    return urlKey.test(key)
      ? sanitizeAnalyticsUrl(value)
      : value.replace(
          /https?:\/\/[^\s"'<>]+|\/digest\/unsubscribe\/[^\s"'<>]+/g,
          sanitizeAnalyticsUrl,
        )
  }
  return value
}
